export enum DateList {
  LAST_WEEK = "Last 7 days",
  LAST_MONTH = "Last 30 days",
  LAST_THREE_MONTHS = "Last 3 months",
  LAST_SIX_MONTHS = "Last 6 months",
  LAST_YEAR = "Last year",
  CUSTOM = "Custom",
}
